import React, { useEffect, useState } from 'react';

import { useForm, Controller } from 'react-hook-form';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  makeStyles,
  Grid,
  Button,
  Checkbox,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import request from '../../services/Request';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Swal from 'sweetalert2';
import { FormLabel } from '@mui/material';
import MaterialTable from 'material-table';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: '100%',
  },
}));

const allFields = [
  'Order_ID',
  'Order_Date',
  'Order_Date_Only',
  'Machine_ID',
  'Machine_Desc',
  'Currency',
  'Tax',
  'Total',
  'Email',
  'Code_Used',
  `Payment_Type`,
  `Product_Name`,
  `Product_UPC_SKU`,
  `Product_Cost_Price`,
  `Product_Unit_Price`,
  `Product_Quantity`,
  'Product_Promotion',
  `Product_Code_Sent`,
  `Product_Discount`,
];

const TransactionSetting = (props) => {
  const classes = useStyles();

  const [client, setClient] = useState([]);
  const [show, setShow] = useState(false);
  const [trans, setTrans] = useState([]);
  const [selectTrans, setSelectTrans] = useState(null);
  const [allMachine, setAllMachine] = useState([]);

  const [allTrans, setAllTrans] = useState([]);

  const defaultValues = {
    period: '1',
    isAllmachine: '1',
    client: null,
    machines: [],
    referTo: '',
    email: '',
    isAllFields: '2',
    fields: [
      `Order_ID`,
      `Order_Date_Only`,
      `Machine_ID`,
      `Machine_Desc`,
      `Product_Name`,
      `Product_UPC_SKU`,
      'Product_Quantity',
      'Total',
      'Tax',
    ],
  };
  const {
    reset,
    handleSubmit,
    register,
    setError,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues });

  const watchAll = watch();
  const getAllEmployeesURL = `/users/getAllEmployees`;

  useEffect(() => {
    request({
      method: 'get',
      url: getAllEmployeesURL,
    }).then((res) => {
      console.log(`allemployee`, res.data);
      setClient(res.data);
    });
  }, []);

  //show all transaction setting
  useEffect(() => {
    request({
      method: 'get',
      url: `/transactionSetting/getAll`,
    }).then((res) => {
      console.log(`alltrans`, res.data);
      setAllTrans(res.data);
    });
  }, []);

  useEffect(() => {
    console.log('watchAll', watchAll);

    setValue('title', '');
    setValue('email', '');
    setValue('period', '1');
    setValue('isAllmachine', '1');
    setValue('machines', []);
    setValue('isAllFields', '2');

    setValue('fields', [
      `Order_ID`,
      `Order_Date_Only`,
      `Machine_ID`,
      `Machine_Desc`,
      `Product_Name`,
      `Product_UPC_SKU`,
      'Product_Quantity',
      'Total',
      'Tax',
    ]);
    setShow(false);
    setSelectTrans(null);
    setTrans([]);
    if (watchAll.client) {
      setValue('referTo', watchAll.client.email);
      try {
        request({
          method: 'get',
          url: `/machines/geMachineEmailBasic/${watchAll.client.email}`,
        }).then((res) => {
          console.log(`allmachine`, res.data);
          setAllMachine(res.data);
          //get all transsetting under client
          request({
            method: 'get',
            url: `/transactionSetting/getByClient/${watchAll.client.email}`,
          }).then((res) => {
            console.log(`alltranssetting`, res.data);
            setTrans(res.data);
          });
        });
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        });
        console.log(error);
      }
    } else {
    }
  }, [watchAll.client]);

  useEffect(() => {
    console.log(`selectTrans`, selectTrans);
    if (selectTrans) {
      setValue('title', selectTrans.title);
      setValue('email', selectTrans.email);
      setValue('period', selectTrans.period);
      setValue('isAllmachine', selectTrans.isAllmachine);
      setValue('isAllFields', selectTrans.isAllFields);

      //refactor machines
      const machines = allMachine.filter((machine) => selectTrans.machines.includes(machine.name));
      setValue('machines', machines);
      //refactor fields
      // const fields = allFields.filter((field) => selectTrans.fields.includes(field));
      setValue('fields', selectTrans.fields);
      setShow(true);
    } else {
      setValue('title', '');
      setValue('email', '');
      setValue('period', '1');
      setValue('isAllmachine', '1');
      setValue('machines', []);
      setValue('isAllFields', '2');

      setValue('fields', [
        `Order_ID`,
        `Order_Date_Only`,
        `Machine_ID`,
        `Machine_Desc`,
        `Product_Name`,
        `Product_UPC_SKU`,
        'Product_Quantity',
        'Total',
        'Tax',
      ]);
      setShow(false);
    }
  }, [selectTrans]);

  const onSubmit = (formatData) => {
    //check is all data entere
    if (
      !formatData.title ||
      !formatData.email ||
      !formatData.period ||
      !formatData.isAllmachine ||
      !formatData.isAllFields ||
      !formatData.fields ||
      !formatData.machines
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please enter all data',
      });
      return;
    }
    const referTo = formatData.client.email;
    const machines = formatData.machines?.map((machine) => machine.name);
    const fields = formatData.fields?.map((field) => field);
    const data = {
      referTo,
      machines,
      title: formatData.title,
      email: formatData.email,
      period: formatData.period,
      isAllFields: formatData.isAllFields,
      fields: fields,
      isAllmachine: formatData.isAllmachine,
    };
    console.log(`selectTrans,`, selectTrans);
    if (!selectTrans) {
      console.log(data);
      request({
        method: 'post',
        url: `/transactionSetting/create`,
        data: data,
      })
        .then((res) => {
          console.log(res);
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Transaction created successfully',
          }).then(() => {
            window.location.reload();
          });
        })
        .catch((err) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          });
          console.log(err);
        });
    } else {
      request({
        method: 'post',
        url: `/transactionSetting/update/${selectTrans._id}`,
        data: data,
      })
        .then((res) => {
          console.log(res);
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Transaction created successfully',
          }).then(() => {
            window.location.reload();
          });
        })
        .catch((err) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          });
          console.log(err);
        });
    }

    // console.log(data);
  };

  const deleteTransSetting = () => {
    if (!selectTrans) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please select a transaction to delete',
      });
      return;
    }
    console.log(`selectTrans`, selectTrans);
    request({
      method: 'post',
      url: `/transactionSetting/delete/${selectTrans._id}`,
    })
      .then((res) => {
        console.log(res);
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Transaction deleted successfully',
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        });
        console.log(err);
      });
  };

  const columns = [
    { title: 'Title', field: 'title' },
    { title: 'Email', field: 'email' },
    {
      title: 'Period',
      field: 'period',
      render: (rowData) => {
        return rowData.period === '1' ? 'Weekly' : 'Monthly';
      },
    },
    {
      title: 'Is All Machine',
      field: 'isAllmachine',
      render: (rowData) => {
        return rowData.isAllmachine === '1' ? 'All Machine' : 'Selected Machine';
      },
    },
    { title: 'Machines', field: 'machines', render: (rowData) => rowData.machines.join(', ') },
    { title: 'Refer To', field: 'referTo' },
  ];

  return (
    <Grid container spacing={4} style={{ padding: '40px' }}>
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Controller
              name="client"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  options={client}
                  value={watchAll.client}
                  onChange={(event, value) => {
                    field.onChange(value);
                  }}
                  getOptionSelected={(option, value) => option._id === value._id}
                  getOptionLabel={(option) => option.groupname}
                  renderOption={(option, { selected }) => (
                    <React.Fragment>{option.groupname}</React.Fragment>
                  )}
                  fullWidth
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Client" />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
              options={trans}
              value={selectTrans}
              onChange={(event, value) => {
                setSelectTrans(value);
              }}
              getOptionSelected={(option, value) => option._id === value._id}
              getOptionLabel={(option) => option.title}
              renderOption={(option, { selected }) => (
                <React.Fragment>{option.title}</React.Fragment>
              )}
              fullWidth
              renderInput={(params) => (
                <TextField {...params} variant="outlined" label="Trans_Setting" />
              )}
            />
          </Grid>
          {watchAll.client && (
            <Grid item xs={6} className="mt-2">
              <Button
                fullWidth
                variant="contained"
                color="primary"
                // disabled={!trans}
                className={classes.submit}
                onClick={() => {
                  setSelectTrans(null);
                  setShow(true);
                }}
              >
                Create New Transaction
              </Button>
            </Grid>
          )}
          {watchAll.client && show && (
            <Grid container spacing={4} item xs={12}>
              <Grid item xs={12}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  fullWidth
                  label="Title"
                  {...register('title', {})}
                />
                {errors.title && <p className="signUpErrorMessage">{errors.title.message}</p>}
              </Grid>
              <Grid item xs={12} style={{ textAlignLast: 'center' }}>
                <FormLabel component="legend">
                  Email address for alert (To use more than one email address, separate the
                  addresses with comma. Example: johndoe@ae.com,william@ba.com,smith.peter@olk.com)
                </FormLabel>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  fullWidth
                  label="Email"
                  {...register('email', {})}
                />
                {errors.email && <p className="signUpErrorMessage">{errors.email.message}</p>}
              </Grid>
              <Grid item xs={4}>
                <Controller
                  name="period"
                  control={control}
                  render={({ field }) => (
                    <FormControl className={classes.formControl}>
                      <InputLabel id="transaction-period-label">Transaction Period</InputLabel>
                      <Select
                        labelId="transaction-period-label"
                        id="transaction-period"
                        {...field}
                        defaultValue={'1'}
                      >
                        {/* <MenuItem value="daily">Daily</MenuItem> */}
                        <MenuItem value="1">Weely</MenuItem>
                        <MenuItem value="2">Monthly</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Controller
                  name="isAllmachine"
                  control={control}
                  render={({ field }) => (
                    <FormControl className={classes.formControl}>
                      <InputLabel id="transaction-isall-label">All Machine</InputLabel>
                      <Select
                        labelId="transaction-isall-label"
                        id="transaction-isall"
                        {...field}
                        defaultValue={'1'}
                      >
                        <MenuItem value="1">All Machine</MenuItem>
                        <MenuItem value="2">Selected Machine</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
              </Grid>

              {watchAll.isAllmachine === '2' && (
                <Grid item xs={4}>
                  <Controller
                    name="machines"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        multiple
                        options={allMachine}
                        value={watchAll.machines}
                        disableCloseOnSelect
                        onChange={(event, value) => {
                          field.onChange(value);
                        }}
                        getOptionSelected={(option, value) => option.name === value.name}
                        getOptionLabel={(option) => option.name}
                        renderOption={(option, { selected }) => (
                          <React.Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.name}
                          </React.Fragment>
                        )}
                        fullWidth
                        renderInput={(params) => (
                          <TextField {...params} variant="outlined" label="Machines" />
                        )}
                      />
                    )}
                  />
                </Grid>
              )}

              <Grid item xs={6}>
                <Controller
                  name="isAllFields"
                  control={control}
                  render={({ field }) => (
                    <FormControl className={classes.formControl}>
                      <InputLabel id="transaction-isallfield-label">Basic Fields</InputLabel>
                      <Select
                        labelId="transaction-isallfield-label"
                        id="transaction-isallfield"
                        {...field}
                        defaultValue={'2'}
                      >
                        {/* <MenuItem value="1">Basic Fields</MenuItem> */}
                        <MenuItem value="2">Selected Fields</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
              </Grid>

              {watchAll.isAllFields === '2' && (
                <Grid item xs={6}>
                  <Controller
                    name="fields"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        multiple
                        options={allFields}
                        value={watchAll.fields}
                        disableCloseOnSelect
                        onChange={(event, value) => {
                          field.onChange(value);
                        }}
                        getOptionSelected={(option, value) => option === value}
                        getOptionLabel={(option) => option}
                        fullWidth
                        renderInput={(params) => (
                          <TextField fullWidth {...params} variant="outlined" label="Fields" />
                        )}
                      />
                    )}
                  />
                </Grid>
              )}
            </Grid>
          )}
          <Grid container spacing={4} item xs={12}>
            <Grid item xs={6}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled={!watchAll.client || !show}
                className={classes.submit}
              >
                Submit
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => {
                  deleteTransSetting();
                }}
                disabled={!watchAll.client || !show}
                className={classes.submit}
              >
                Delete
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <MaterialTable columns={columns} data={allTrans} title="All Transaction Setting" />
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
};

export default TransactionSetting;
